/**
 * Datepicker Class
 *
 */
export default class Datepicker {


    // constructor
    constructor(selector) {
        this.datePicker(selector);
    }

    // init datepicker
    datePicker(selector) {
        let vm = $(selector);
        vm.picker = '[data-datepicker]';
        vm.pickerToggle = '[data-datepicker-toggle]';
        vm.pickerToggleIcon = 'ui_calendar';
        vm.pickerToggleCloseIcon = 'ui_close';

        vm.find(vm.picker).each(function() {
            let $this = $(this);
            let pickadate = $this.pickadate({
                monthsFull: tncpConstants.pickadate.monthsFull,
                monthsShort: tncpConstants.pickadate.monthsShort,
                weekdaysFull: tncpConstants.pickadate.weekdaysFull,
                weekdaysShort: tncpConstants.pickadate.weekdaysShort,
                today: tncpConstants.pickadate.today,
                clear: tncpConstants.pickadate.clear,
                close: tncpConstants.pickadate.close,
                firstDay: tncpConstants.pickadate.firstDay,
                format: tncpConstants.pickadate.format,
                formatSubmit: tncpConstants.pickadate.formatSubmit,
                onOpen: function() {
                    $this.nextAll(vm.pickerToggle).attr( 'data-icon', vm.pickerToggleCloseIcon );
                },
                onClose: function() {
                    $this.nextAll(vm.pickerToggle).attr( 'data-icon', vm.pickerToggleIcon );
                }
            });
            let picker = pickadate.pickadate('picker');
            if (this.dataset.defaultDate) {
                let date = new Date(this.dataset.defaultDate);
                picker.set('select', date);
            }

            if (this.dataset.minDate) {
                let minDate = new Date(this.dataset.minDate);
                picker.set('min', minDate);
            }

            if (this.dataset.datepickerDisable) {
                let test = JSON.parse(this.dataset.datepickerDisable);
                picker.set('disable', test);
            }

            $this.removeAttr('readonly');
            $this.on('blur', function() {
                let dateParts = $this.val().split('.');
                if (dateParts.length === 3) {
                    let parseString = dateParts[2] + '-' + dateParts[1] + '-' + dateParts[0];
                    if (Date.parse(parseString)) {
                        picker.set('select', Date.parse(parseString), { format: 'yyyy-mm-dd' });
                    }

                    return;
                }

                picker.set('select', picker.get('select'));
            });

            picker.set('editable', true);
            $this.nextAll(vm.pickerToggle).
            on( 'click', function( event ) {
                if ($this.hasClass('picker__input--active')) {
                    picker.close()
                } else {
                    $this.focus();
                }
                event.preventDefault();
                event.stopPropagation()
            }).
            on( 'mousedown', function(event) {
                event.preventDefault()
            });

        });
    }

}
